import { http } from "../helpers/easyindustriaapi/config";

export default class ProdutoController {
  /**
   * Busca produtos por empresa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Array>} - Lista de produtos
   */
  static async getProdutos(empresaId) {
    const response = await http.get(
      `produto?empresa_id=${empresaId}`
    );
    return response.data;
  }

  /**
   * Busca produto por ID
   * @param {number} id - ID do produto
   * @returns {Promise<Object>} - Produto encontrado
   */
  static async getProduto(id) {
    const response = await http.get(
      `produto/${id}`
    );
    return response.data;
  }

  /**
   * Cria um novo produto
   * @param {Object} produto - Dados do produto
   * @returns {Promise<Object>} - Produto criado
   */
  static async createProduto(produto) {
    const response = await http.post(
      `produto`,
      produto
    );
    return response.data;
  }

  /**
   * Atualiza um produto existente
   * @param {number} id - ID do produto
   * @param {Object} dados - Dados para atualização
   * @returns {Promise<Object>} - Produto atualizado
   */
  static async updateProduto(id, dados) {
    const response = await http.put(
      `produto/${id}`,
      dados
    );
    return response.data;
  }

  /**
   * Remove um produto
   * @param {number} id - ID do produto
   * @returns {Promise<Object>} - Resultado da remoção
   */
  static async deleteProduto(id) {
    const response = await http.delete(
      `produto/${id}`
    );
    return response.data;
  }

  /**
   * Busca produto por código interno
   * @param {number} empresaId - ID da empresa
   * @param {string} codigo - Código interno do produto
   * @returns {Promise<Object>} - Produto encontrado
   */
  static async getProdutoByCodigo(empresaId, codigo) {
    const response = await http.get(
      `produto?empresa_id=${empresaId}`
    );
    const produtos = response.data;
    return produtos.find(p => p.produto_cod_int === codigo);
  }

  /**
   * Cria produtos em lote
   * @param {Array} produtos - Array de produtos para criar
   * @returns {Promise<Object>} - Resultado da criação em lote
   */
  static async createProdutosBatch(produtos) {
    const created = [];
    const errors = [];

    for (const produto of produtos) {
      try {
        const response = await this.createProduto(produto);
        created.push(response);
      } catch (error) {
        errors.push({
          produto: produto,
          error: error.message
        });
      }
    }

    return {
      created,
      errors
    };
  }
}
